import { Button } from "@mui/material";
import { useContext, useRef, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import userCheck from '../../Assets/Images/user-check.svg';
import infoCircle from '../../Assets/Images/info-circle.svg';
import qrCode from '../../Assets/Images/qr-code.svg';
import qrScan from '../../Assets/Images/qr-scan.svg';
import video1 from '../../Assets/Images/video-thumbnail-1.jpg';
import video2 from '../../Assets/Images/video-thumbnail-2.jpg';
import video3 from '../../Assets/Images/video-thumbnail-3.jpg';
import envelope from '../../Assets/Images/envelope.svg';
import VideoCard from "../../Components/VideoCard/VideoCard";
import AuthContext from "../../Context/AuthContext";
import QRCode from "react-qr-code";
import { DashboardContext } from "../../Context/DashboardContext";
import linkicon from '../../Assets/Images/link-icon.svg';

const DashboardOnboarding = () => {

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { id } = useParams();
  const [email, setEmail] = useState('');
  const [disableSend, setDisableSend] = useState(true);

  const authCtx = useContext(AuthContext);
  const dashboardCtx = useContext(DashboardContext);
  const qrRef = useRef();

  const [qrLink, setQrLink] = useState(localStorage.getItem('configureUrl'))

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);

    if (emailValue === '' || !validateEmail(emailValue)) {
      setDisableSend(true);
    } else {
      setDisableSend(false);
    }
  };

  const downloadQRCode = () => {
    const svg = qrRef.current.querySelector('svg');
    if (!svg) return;

    const svgData = new XMLSerializer().serializeToString(svg);
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'qrcode.svg';
    link.click();

    URL.revokeObjectURL(url);
  };

  const videos = [
    {
      id: 1,
      title: 'Preparing to Deploy Your Survey',
      type: 'type',
      time: '5 min',
      image: video1
    },
    {
      id: 2,
      title: 'Using The Platform',
      type: 'type',
      time: '9 min',
      image: video2
    },
    {
      id: 3,
      title: 'Configuring your account',
      type: 'type',
      time: '2 min',
      image: video3
    },
  ]

  // console.log("authCtx", authCtx)
  

  return (
    <div className="container dashboard-onboarding-container">
      <div className="header">
        <h1 className="welcome-text">Welcome, {authCtx?.firstName}!</h1>
        <div className="surveys-info">
          <img src={userCheck} alt="" />
          <p>0 surveys taken</p>
        </div>
      </div>
      <div className="dashboard-body">
        <div className="dashboard-left survey-info dashboard-card">
          <div className="header">
            <p>Collect responses</p>
            {/* <img src={infoCircle} alt="" /> */}
          </div>
          <div className="content">
            <div className="qr-section">
              <div className="qr-code" ref={qrRef}>
                <QRCode value={`https://${qrLink}.scatter.us/`} size={256} style={{ height: "auto", maxWidth: "50%", width: "50%", marginLeft: '50%', transform: 'translateX(-50%)' }} />
                {/* <img src={qrCode} alt="" /> */}
              </div>
              <p className="qr-name">Church Name 2024 Survey QR Code</p>
            </div>
            <div className="deploy-section">
              <p className="heading">Ready to start?</p>
              <ol>
                <li>Open the camera app on your phone and test the QR code.</li>
                <li>Consider sharing the survey on a Sunday morning. Our data shows that most churches have a higher response from their congregation when Scatter is presented and shared from the pulpit.</li>
                <li>Download and share the QR code by clicking the "Download QR code" button below if you are creating a slide deck for Sunday morning, or copy the survey link below if you want to insert it in an email.</li>
              </ol>
              <div className="qr-code-link-container">
                <button onClick={downloadQRCode}>
                  <img src={qrScan} alt="" />
                  <p>DOWNLOAD QR CODE </p>
                </button>
                <a href={`https://${qrLink}.scatter.us/`}>
                  <p><img src={linkicon} alt="" />Survey Link</p>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="dashboard-right">
          <div className="video-tutorials dashboard-card">
            <div className="header">
              <p>Video Tutorials</p>
            </div>
            <div className="content">
              <div className="videos-grid">
                {videos.map(video => <div className="card-container"><VideoCard key={video.id} video={video} /></div>)}
              </div>
              <div className="coming-soon-overlap">
                <div className="overlap-box">
                  <div className="background"></div>
                  <div className="coming-soon-msg">
                    This feature is coming soon!
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="invite-box dashboard-card">
            <div className="header">
              <p>Add your team</p>
            </div>
            <div className="content">
              <div className="email-box">
                <div className="input">
                  <input type="email" placeholder="Invite by email" value={email} onChange={handleEmailChange} />
                  <img src={envelope} alt="" />
                </div>
                <Button disabled={disableSend}>Send</Button>
              </div>
              <div className="email-list">
                <div className="no-members-msg">Added Team members will display here</div>
              </div>
              <div className="coming-soon-overlap">
                <div className="overlap-box">
                  <div className="background"></div>
                  <div className="coming-soon-msg">
                    This feature is coming soon!
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardOnboarding;
